import { createEntityAdapter } from "@reduxjs/toolkit";
import { ServiceType } from "./dataTypes";

export const serviceTypeAdapter = createEntityAdapter<ServiceType>({});
